import { UpsellSequence } from '@/modules/upsell/application/upsell-sequence';

export default ({ store }, inject) => {
  const sequence = new UpsellSequence();

  const persist = () => {
    store.dispatch('upsell-sequence/setSequenceSnapshot', sequence.snapshot());
  };

  const initialSnapshot = store.getters['upsell-sequence/getSequenceSnapshot'];
  if (initialSnapshot) {
    sequence.restore({
      sequence: initialSnapshot.sequence ?? null,
      sequenceTree: initialSnapshot.sequenceTree ?? null,
      currentSequenceTree: initialSnapshot.currentSequenceTree ?? null,
      cursor: initialSnapshot.cursor ?? null,
      progressIndex: initialSnapshot.progressIndex ?? 0,
      progressTotal: initialSnapshot.progressTotal ?? 0,
    });
  }

  const facade = {
    initialize() {
      facade.clearOverlay();
      const snapshot = store.getters['upsell-sequence/getSequenceSnapshot'];
      const result = sequence.initialize({
        sequence: snapshot?.sequence ?? null,
        sequenceTree: snapshot?.sequenceTree ?? null,
      });
      persist();
      return result;
    },
    next(outcome) {
      const result = sequence.next(outcome);
      persist();
      store.dispatch('upsell-sequence/setUpsellOverlay', null);
      return result;
    },
    advanceWithinBundle() {
      const result = sequence.advanceWithinBundle();
      persist();
      store.dispatch('upsell-sequence/setUpsellOverlay', null);
      return result;
    },
    goBackInBundle() {
      const result = sequence.goBackInBundle();
      persist();
      store.dispatch('upsell-sequence/setUpsellOverlay', null);
      return result;
    },
    transitionToEmptyCart() {
      const result = sequence.transitionToEmptyCart();
      persist();
      store.dispatch('upsell-sequence/setUpsellOverlay', null);
      return result;
    },
    currentNode() {
      return sequence.currentNode();
    },
    isCompleted() {
      return sequence.isCompleted();
    },
    progress() {
      return sequence.progress();
    },
    setOverlay(name) {
      store.dispatch('upsell-sequence/setUpsellOverlay', name);
    },
    clearOverlay() {
      store.dispatch('upsell-sequence/setUpsellOverlay', null);
    },
    reset() {
      sequence.reset();
      persist();
      store.dispatch('upsell-sequence/setUpsellOverlay', null);
    },
  };

  inject('upsellSequence', facade);
};
